import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import styles from './ReservesSlider.scss'

import {
    RESERVES_SLIDER_RANGE_LABEL,
} from './constants.jsx'

export default class ReservesSlider extends React.Component {

    static propTypes = {
        maxValue: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
        maxAvailableValue: PropTypes.number.isRequired,
        handleChange: PropTypes.func.isRequired,
        handleHover: PropTypes.func.isRequired,
    }
    static defaultProps = {
        maxValue: 50, // values.last
        value: 1,
    }

    static values = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20, 30, 40, 50]

    handleChange = (event) => {
        const value = ReservesSlider.values[event.target.value]
        if (value > 0) {
            this.props.handleChange(value)
        }
    }

    render() {
        const scaleItems = ReservesSlider.values.map((value, index) => {
            const scaleItemClassName = classNames(styles.scaleItem, {
                [styles.scaleItem__unavailable]: value > this.props.maxAvailableValue,
            })
            return (
                <div className={scaleItemClassName} key={index}>
                    <span className={styles.scaleCaption}>
                        {value}
                        <span className={styles.scaleCaptionGradient}>{value}</span>
                    </span>
                </div>
            )
        })

        const lastValueIndex = ReservesSlider.values.length - 1

        let availableWidth
        if (this.props.maxAvailableValue >= this.props.maxValue) {
            availableWidth = 1
        } else {
            const maxAvailableValue = ReservesSlider.values.find((value, index) => {
                const nextValue = ReservesSlider.values[index + 1]
                return value <= this.props.maxAvailableValue && nextValue > this.props.maxAvailableValue
            })
            availableWidth = ReservesSlider.values.indexOf(maxAvailableValue) / lastValueIndex
        }

        const valueIndex = ReservesSlider.values.indexOf(this.props.value)
        const selectedWidth = valueIndex / lastValueIndex

        const availableSelectionWidth = Math.min(selectedWidth, availableWidth)

        return (
            <div className={styles.base}>
                <p className={styles.label}>{RESERVES_SLIDER_RANGE_LABEL}</p>
                <div className={styles.range}>
                    <div className={styles.scale}>
                        {scaleItems}
                    </div>
                    <div className={styles.holder}>
                        <div className={styles.available} style={{ width: availableWidth * 100 + '%' }}></div>
                        <div className={styles.selected} style={{ width: availableSelectionWidth * 100 + '%' }}></div>
                        <div className={styles.wrapper}>
                            <input
                                className={styles.input}
                                type="range"
                                min={0}
                                value={valueIndex}
                                max={lastValueIndex}
                                onMouseEnter={this.props.handleHover}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/ReservesSlider/ReservesSlider.jsx